import { Form } from 'antd';
import { useField } from 'formik';
import { isEqual } from 'lodash/fp';
import { type IdentityNumberFieldProps } from '../../../components/fields/IdentityNumberField';
import { StyledTextFieldWrapper } from './shared';
import useRenderTooltip from './useRenderTooltip';
import { getTextFieldState } from './utils';

const IdentityNumberField = (props: IdentityNumberFieldProps) => {
    const { name, required, label, itemProps, format, tooltip, status, placeholder, disabled, removeWhiteSpace } =
        props;

    const [field, meta, helpers] = useField({ name });

    const renderTooltip = useRenderTooltip(tooltip);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let { value } = event.target;

        if (removeWhiteSpace && typeof value === 'string') {
            value = value.replace(/\s/g, '');
        }

        if (format) {
            value = format(value);
        }

        helpers.setValue(value);
    };

    const hasError = !!meta?.error && (meta?.touched || !isEqual(meta?.initialValue, meta?.value));
    const errorMessage = Array.isArray(meta?.error) ? '' : meta?.error;

    return (
        <Form.Item {...itemProps} required={required}>
            <StyledTextFieldWrapper state={hasError ? 'error' : getTextFieldState(status)}>
                <span slot="label">
                    {label}
                    {renderTooltip()}
                </span>
                {itemProps?.help && <span slot="description">{itemProps?.help}</span>}
                <input
                    {...field}
                    autoComplete="off"
                    disabled={disabled}
                    onChange={handleChange}
                    placeholder={placeholder}
                    required={required}
                    type="text"
                    value={field.value || ''}
                />
                {hasError && <span slot="message">{errorMessage}</span>}
            </StyledTextFieldWrapper>
        </Form.Item>
    );
};
export default IdentityNumberField;
